import { FormInstance, RuleObject } from 'antd/es/form';

import {
  formatPhoneNumber,
  isEmptyPhoneNumber,
  validatePhoneNumber,
} from '~/core/helpers';
import { CustomerDataModel } from '~/core/models';

export const testIsNameSuspect = (name: string | undefined) =>
  !!name?.length && (name?.trim() ?? '').split(/\s+/).length < 2;

export const testIsAddressSuspect = (
  address1: string,
  _address2 = '',
  _city = '',
  _state = '',
  _zip = ''
) => {
  if (!address1 || address1?.length === 0) {
    return false;
  }

  return !/^(?=.*\d)(?=.*\b)\w+\s+\w+/.test(address1.trim());
};

export const addressWarningValidator = (_rule: RuleObject, value: string) => {
  if (testIsAddressSuspect(value, '', '', '', '')) {
    return Promise.reject('Please verify the address is correct');
  }

  return Promise.resolve();
};

export const nameWarningValidator = (_rule: RuleObject, value: string) => {
  if (testIsNameSuspect(value)) {
    return Promise.reject('Please verify the name is correct');
  }

  return Promise.resolve();
};

export const phoneValidator = (_rule: RuleObject, value: string) => {
  // zero length is valid, use required to check for this
  // 7 digits simple numbers are acceptable, area code can't start with 0 or 1
  // regex is a bare minimum validation of numbers and characters, no actual format for now
  // TODO - do real validation of phone numbers or we're going to have bad data

  if (isEmptyPhoneNumber(value) || validatePhoneNumber(value, ['US'])) {
    return Promise.resolve();
  } else {
    return Promise.reject('Invalid phone number');
  }
};

export const reformatPhones = (form: FormInstance<CustomerDataModel>) => {
  const fields = ['phone', 'alternatePhone'] as const;

  fields.forEach((field) => {
    const value = form.getFieldValue(field);

    if (!value) {
      return;
    }
    form.setFields([{ name: field, value: formatPhoneNumber(value) }]);
  });
};

export const whichPhoneRequired = (
  phone?: string,
  altPhone?: string
): [isPhoneRequired: boolean, isAltPhoneRequired: boolean] => {
  const isPhone = Boolean(phone?.trim().length);
  const isAlt = Boolean(altPhone?.trim().length);
  const isPhoneRequired = !isAlt || (isAlt && isPhone);
  const isAltPhoneRequired = !isPhone;

  return [isPhoneRequired, isAltPhoneRequired];
};

/**
 * sendCustomerEmail is stored/sent in the positive sense (true = send), but
 * the checkbox reads "Do not email me an estimate" (checked = suppress).
 * Guarding with `?? true` here is the fix for a real bug EE2 shipped: without
 * it, an estimate saved before this field existed (sendCustomerEmail
 * undefined) would default the checkbox to CHECKED instead of unchecked.
 */
export const toDoNotEmailEstimate = (sendCustomerEmail?: boolean): boolean =>
  !(sendCustomerEmail ?? true);

export const toSendCustomerEmail = (doNotEmailEstimate?: boolean): boolean =>
  !doNotEmailEstimate;
